import { RechercheForm } from '@features/mes-financements/features/mes-financements-recherche/models/recherche-form';
import { createReducer, on } from '@ngrx/store';
import { CategoryFolderEnum } from '@shared/enums/categorie.enum';
import { FormGroupState } from '@shared/models/common';
import { MesFinancementSearchFormActions } from '@features/mes-financements/store/search/search.actions';

export const featureKey = 'mesFinancementsRechercheForm';

export interface RechercheFormState extends FormGroupState<RechercheForm> {
  categorieDossier: CategoryFolderEnum;
  querySiret: string;
  displayDispositif: boolean;
  displayStatus: boolean;
  displaySolde: boolean;
  resetDone: boolean;
  keepHistory: boolean;
}

export const initialState: RechercheFormState = {
  querySiret: '',
  value: new RechercheForm(),
  categorieDossier: CategoryFolderEnum.TOUTES,
  checkingForm: false,
  isValid: false,
  errorMessage: null,
  errors: [],
  displayDispositif:false,
  displayStatus: false,
  displaySolde: false,
  resetDone: true,
  keepHistory: true
};

export const mesFinancementsRechercheReducers = createReducer(
  initialState,
  on(MesFinancementSearchFormActions.updateSearchForm, (state, { form }) => ({
    ...state,
    value: form,
  })),

  on(MesFinancementSearchFormActions.updateCategorieDossier, (state, { categorieDossier }) => ({
    ...state,
    categorieDossier,
  })),
  on(MesFinancementSearchFormActions.resetSearchForm, (state) => ({
    ...state,
    querySiret: '',
    value: new RechercheForm(),
  })),
  on(MesFinancementSearchFormActions.searchSiretFromQuery, (state, { querySiret }) => ({
    ...state,
    querySiret,
  })),
  on(MesFinancementSearchFormActions.searchSiretFromQueryFailure, (state, { validationErrors }) => ({
    ...state,
    errors: validationErrors
  })),
  on(MesFinancementSearchFormActions.searchSiretFromQuerySucces, (state => ({
    ...state,
    errors: []
  }))),

  on(MesFinancementSearchFormActions.updateDispositif, (state, { typeDispositif, typeDispositifLibelle }) => ({
    ...state,
    value: {
      ...state.value,
      typeDispositif,
      typeDispositifLibelle
    },
  })),
  on(MesFinancementSearchFormActions.displayDispositif, (state, { value }) => ({
    ...state,
    displayDispositif: value,
  })),
  on(MesFinancementSearchFormActions.updateStatus, (state, { status, statusLibelle }) => ({
    ...state,
    value: {
      ...state.value,
      statut: status,
      statutLabel : statusLibelle
    },
  })),
  on(MesFinancementSearchFormActions.displayStatus, (state, { value }) => ({
    ...state,
    displayStatus: value,
  })),
  on(MesFinancementSearchFormActions.updateSolde, (state, { solde }) => ({
    ...state,
    value: {
      ...state.value,
      solder: solde
    },
  })),
  on(MesFinancementSearchFormActions.displaySolde, (state, { value }) => ({
    ...state,
    displaySolde: value,
  })),
  on(MesFinancementSearchFormActions.resetDone, (state, { resetDone }) => ({
    ...state,
    resetDone,
  })),
  on(MesFinancementSearchFormActions.updateKeepHistory, (state, { value }) => ({
    ...state,
    keepHistory: value,
  }))
);
